<template>
    <div class="report-actions-menu" @click.stop>
        <b-dropdown
            size="sm"
            variant="outline-secondary"
            :right="right"
            no-caret
            toggle-class="report-actions-menu__toggle"
            menu-class="report-actions-menu__dropdown"
        >
            <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
                <span v-if="buttonLabel" class="ml-1">{{ buttonLabel }}</span>
            </template>

            <b-dropdown-item
                v-if="showPhotoActions && canManagePhotos"
                @click="$emit('upload-photos', report)"
            >
                <i class="fas fa-cloud-upload-alt text-primary"></i>
                Догрузить фото
            </b-dropdown-item>
            <b-dropdown-item
                v-if="showPhotoActions && canResendPhotos"
                @click="$emit('resend-photos', report)"
            >
                <i class="fas fa-paper-plane text-warning"></i>
                Отправить неотправленные фото
            </b-dropdown-item>
            <b-dropdown-item
                v-if="canResendReport"
                @click="$emit('resend-report', report)"
            >
                <i class="fab fa-telegram-plane text-info"></i>
                Повторно отправить отчёт
            </b-dropdown-item>

            <b-dropdown-divider v-if="(showPhotoActions && canManagePhotos) || canResendReport"></b-dropdown-divider>

            <b-dropdown-item
                v-if="report && report.telegram_url"
                :href="report.telegram_url"
                target="_blank"
                rel="noopener"
            >
                <i class="fab fa-telegram-plane text-info"></i>
                Открыть в Telegram
            </b-dropdown-item>
            <b-dropdown-item @click="$emit('copy-link', report)">
                <i class="fas fa-link text-secondary"></i>
                Скопировать ссылку
            </b-dropdown-item>

            <b-dropdown-divider v-if="canRequestAnnulment"></b-dropdown-divider>

            <b-dropdown-item v-if="canRequestAnnulment" @click="$emit('delete-request', report)">
                <i class="fas fa-ban text-danger"></i>
                Заявка на аннулирование
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import {hasUnsentPhotosToResend} from './reportMediaStatus';
import {canRequestReportAnnulment, isReportAnnulled} from './reportAnnulmentAccess';

export default {
    name: 'ReportActionsMenu',
    props: {
        report: {
            type: Object,
            default: null
        },
        buttonLabel: {
            type: String,
            default: ''
        },
        right: {
            type: Boolean,
            default: true
        },
        showPhotoActions: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser || {};
        },
        currentUserId() {
            return Number(this.currentUser.userId || this.currentUser.user_id || this.currentUser.id);
        },
        isAnnulled() {
            return isReportAnnulled(this.report);
        },
        canRequestAnnulment() {
            return canRequestReportAnnulment(
                this.report,
                this.currentUser,
                this.$store.getters.isAdmin
            );
        },
        canResendReport() {
            const roles = Array.isArray(this.currentUser.roles) ? this.currentUser.roles : [];
            return !this.isAnnulled && (this.$store.getters.isAdmin || roles.indexOf('Top') !== -1);
        },
        canManagePhotos() {
            if (this.isAnnulled || !this.report || !this.report.object) {
                return false;
            }
            if (this.canResendReport) {
                return true;
            }
            if (!this.currentUserId) {
                return false;
            }
            const object = this.report.object;
            const allowedIds = [
                object.curator_id,
                object.main_staff_id
            ].concat((object.has_access_users || []).map(user => user.user_id));

            return allowedIds.some(id => Number(id) === this.currentUserId);
        },
        hasPhotosToResend() {
            return hasUnsentPhotosToResend(this.report);
        },
        canResendPhotos() {
            return this.canManagePhotos && this.hasPhotosToResend;
        }
    }
};
</script>

<style scoped>
.report-actions-menu {
    display: inline-flex;
}

.report-actions-menu >>> .report-actions-menu__toggle {
    align-items: center;
    display: inline-flex;
    font-weight: 700;
    gap: 4px;
    justify-content: center;
    min-height: 30px;
    min-width: 34px;
}

.report-actions-menu >>> .dropdown-item {
    align-items: center;
    display: flex;
    gap: 8px;
}

.report-actions-menu >>> .dropdown-item i {
    text-align: center;
    width: 16px;
}
</style>
